<template>
  <div>
    <el-card style="margin-bottom: 20px;">
      <div slot="header" class="clearfix">
        <h3>{{ $t("app.Announcement") }}</h3>
      </div>
      <div  class="lineFeed" style="font-size: 14px;">
        {{ result }}
      </div>
    </el-card>
    <el-card v-if="$store.state.Config.studentType === 'old'">
      <div slot="header" class="clearfix">
        <h3>{{ $t("app.checkOutTime") }}</h3>
      </div>
      <div class="lineFeed" style="font-size: 14px;">
          {{ checkOutTime }}
      </div>
    </el-card>
  </div>
</template>
<script>
import { getResultNew } from "@/api/newStudent";
import { getResult, getTime } from "@/api/oldStudent";
export default {
  data() {
    return {
      result: "分配結果",
      checkOutTime: "預約退宿時間"
    };
  },
  created() {
    if (this.$store.state.Config.studentType === "new") {
      getResultNew({
        applicationCode: this.$store.state.Config.applicationId,
        idNo: this.$store.state.Config.cardId
      }).then(res => {
        this.result = res.data;
      });
    } else if (this.$store.state.Config.studentType === "old") {
      getResult().then(res => {
        this.result = res.data;
      });
      getTime().then(res => {
        this.checkOutTime = res.data;
      });
    }
  }
};
</script>
